import { useSplitTreatments } from '@splitsoftware/splitio-react';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

import { FeatureFlags } from '~constants/featureFlags';
import { AnalyticsController } from '~hooks/useAnalytics/AnalyticsController';
import { useStores } from '~store';

const ALL_FLAGS = Object.values(FeatureFlags);

// Registers the currently-enabled Split flags as a PostHog super-property so
// every captured event can be segmented by which flags were on. Only 'on' flags
// are stored; a flag's absence from the array means off or unassigned.
const SplitFlagAnalyticsSync = observer(() => {
  const { treatments, isReady } = useSplitTreatments({ names: ALL_FLAGS });
  const { userStore } = useStores();
  // AnalyticsController.reset() clears all super-properties. Depending on the
  // acting user's id re-registers them whenever the identity changes without a
  // remount, independent of whether Split re-evaluates.
  const userId = userStore.user.id;

  useEffect(() => {
    if (!isReady) return;
    const enabledFlags = ALL_FLAGS.filter((flag) => treatments[flag]?.treatment === 'on');
    AnalyticsController.register({ enabled_feature_flags: enabledFlags });
  }, [isReady, treatments, userId]);

  return null;
});

export default SplitFlagAnalyticsSync;
